import React, { useEffect, useState } from 'react';
import { useDialog } from '@context/DialogContext';
import Pagination from '@components/common/Shared/Pagination';
import SelfAccountListTable from '@components/common/Table/SelfAccountListTable';
import api from '@api/axios';

const SelfAccountList = () => {
  const [selfAccountList, setSelfAccountList] = useState([]);
  const [selfAccountListTotal, setSelfAccountListTotal] = useState(0);
  const [checkedAccountList, setCheckedAccountList] = useState([]);
  const [page, setPage] = useState(1);
  const { showDialog } = useDialog();
  const [pageSize, setPageSize] = useState(30);
  const [name, setName] = useState('');
  const [accountType, setAccountType] = useState('개인사업자');
  const [orderBy, setOrderBy] = useState('ceo_name');
  const [orderDir, setOrderDir] = useState('ASC');

  // 페이지 이동
  const onDefaultSearch = (page) => {
    setCheckedAccountList([]); 
    setPage(page);

    let url = `/api/account/readAccountList?`;
    url += page ? `&page=${page}` : '';
    url += pageSize ? `&pageSize=${pageSize}` : '';
    url += accountType ? `&accountType=${accountType}` : '';
    url += name ? `&name=${name}` : '';
    url += orderBy ? `&orderBy=${orderBy}` : '';
    url += orderDir ? `&orderDir=${orderDir}` : '';

    api
      .get(url)
      .then((res) => {
        console.log('res');
        console.log(res);
        setSelfAccountList(res.data.result.rows);
        setSelfAccountListTotal(res.data.result.total);
      });
  };

  useEffect(() => {
    onDefaultSearch(page);
  }, [page, orderBy, orderDir]);

  useEffect(() => {
    onSearch();
    setPage(1);
  }, [pageSize]);
  
  // 검색
  const onSearch = () => {
    setCheckedAccountList([]); 

    let url = `/api/account/readAccountList?`;
    url += pageSize ? `&pageSize=${pageSize}` : '';
    url += accountType ? `&accountType=${accountType}` : '';
    url += name ? `&name=${name}` : '';

    api
      .get(url)
      .then((res) => {
        console.log('res');
        console.log(res);

        setSelfAccountList(res.data.result.rows);
        setSelfAccountListTotal(res.data.result.total);
        setPage(1);
      });
  };

   // 체크박스 선택 및 미선택택(개별 선택)
  const handleCheckboxChange = (e, companyId) => {
    if (e.target.checked) {
      setCheckedAccountList([...checkedAccountList, companyId]);        
    } else {
      setCheckedAccountList(checkedAccountList.filter((id) => id !== companyId));
    }
  };

  // 체크박스 선택 및 미선택시(전체 선택)
  const handleCheckAll = (e) => {
    if (e.target.checked) {
      setCheckedAccountList(selfAccountList.map((item) => item.id));
    } else {
      setCheckedAccountList([]); 
    }
  };

  // 체크한 개인사업자 리스트 삭제
  const onDeleteAccount = () => {
    if (checkedAccountList.length === 0) {
      showDialog({
        type: 'alert',
        title: '확인',
        message: '삭제할 개인사업자 정보를 선택해 주세요.',
      });
    }
    else {
      showDialog({
        type: 'confirm',
        title: '삭제',
        message: '정말 삭제하시겠습니까?',
        onConfirm: () => {
            api
        .post('/api/account/deleteAccount', {
          accountList: checkedAccountList,
          accountType: accountType
        })
        .then((res) => {
          console.log('onDeleteAccount :: res');
          console.log(res);
        if (res.status === 200) {
          showDialog({ title: '개인사업자 리스트 삭제', message: '삭제되었습니다.', modalType: 'alert' });
          onSearch();
        }
      })
      .catch((err) => {
        console.log('onDeleteAccount :: err');
        console.log(err);
      });
        },
      });
    }
  };

  const isCheckboxAllSelect = selfAccountList.length > 0 && selfAccountList.length === checkedAccountList.length;

  return (
    <React.Fragment>
      <SelfAccountListTable
        selfAccountList={selfAccountList}
        selfAccountListTotal={selfAccountListTotal}
        checkedAccountList={checkedAccountList}    
        setName={setName}
        onSearch={onSearch}
        onDefaultSearch={onDefaultSearch}
        onDeleteAccount={onDeleteAccount}
        handleCheckboxChange={handleCheckboxChange}
        handleCheckAll={handleCheckAll}
        isCheckboxAllSelect={isCheckboxAllSelect}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        orderDir={orderDir}
        setOrderDir={setOrderDir}
      />
    </React.Fragment>
  );
};

export default SelfAccountList;
